import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=5cb6a5d3&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=ts&"
export * from "./Playground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6a5d3",
  null
  
)

export default component.exports